const allBlocks = [...document.querySelectorAll("[data-option-handle]")];
const dropdownEl = document.querySelector(".dropdown-toggle-js");

const contentToggleHandler = (dropdownValue) => {
  allBlocks.forEach((block) => block.classList.remove("is-visible"));

  const relevantBlocks = allBlocks.filter(
    (block) =>
      block.getAttribute("data-option-handle") === dropdownValue ||
      block.getAttribute("data-option-handle") === "all"
  );

  if (!relevantBlocks) return;

  relevantBlocks.forEach((block) => block.classList.add("is-visible"));
};

// add param to URL
function addParam(key, value) {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.pushState({}, "", url);
}

function getLocation() {
  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => locationChecker(data))
    .catch((error) => console.error("Error:", error));
}

function locationChecker(data) {
  // Austria, Belgium, Denmark, Finland, France, Germany, Luxembourg, Netherlands, Ireland, Sweden
  const europeNorth = [
    "AT",
    "BE",
    "DK",
    "FI",
    "FR",
    "DE",
    "LU",
    "NL",
    "IE",
    "SE",
  ];
  // Bulgaria, Croatia, Cyprus, Czechia, Estonia, Greece, Hungary, Italy, Latvia, Lithuania, Malta, Poland, Portugal, Romania, Slovakia, Slovenia, Spain
  // prettier-ignore
  const europeSouth = ['BG','HR','CY','CZ','EE','GR','HU','IT','LV','LT','MT','PL','PT','RO','SK','SI','ES'];
  // Norway, Switzerland
  const norwayAndSwitzerland = ["NO", "CH"];
  // United Kingdom
  const unitedKingdom = ["GB"];
  // United States
  const usa = ["US"];

  if (data !== "undefined") {
    var country_code = data.country;
    if (europeNorth.includes(country_code)) {
      dropdownEl.value = "europe-north";
      contentToggleHandler("europe-north");
    } else if (europeSouth.includes(country_code)) {
      dropdownEl.value = "europe-south";
      contentToggleHandler("europe-south");
    } else if (norwayAndSwitzerland.includes(country_code)) {
      dropdownEl.value = "norway-and-switzerland";
      contentToggleHandler("norway-and-switzerland");
    } else if (unitedKingdom.includes(country_code)) {
      dropdownEl.value = "uk";
      contentToggleHandler("uk");
    } else if (usa.includes(country_code)) {
      dropdownEl.value = "usa";
      contentToggleHandler("usa");
    } else {
      dropdownEl.value = "rest-of-the-world";
      contentToggleHandler("rest-of-the-world");
    }
  }
}

function init() {
  contentToggleHandler(dropdownEl.value);
  dropdownEl.addEventListener("change", (e) => {
    var value = e.target.value;
    contentToggleHandler(value);
    addParam("delivery", value);
  });

  const urlParams = new URLSearchParams(window.location.search);
  const delivery = urlParams.get("delivery");
  if (delivery) {
    dropdownEl.value = delivery;
    contentToggleHandler(delivery);
  } else {
    getLocation();
  }
}

window.addEventListener("DOMContentLoaded", (e) => {
  init();
});
